import Vue from "vue"

export const PostProcessingsRequestEventBus = new Vue()
export const PostProcessingsResultsEventBus = new Vue()
